import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';

function ProductCard({ producto }) {
  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext); 

  // --- Lógica de Imagen ---
  const nombreArchivo = producto.imagen_url || producto.imagen || producto.foto;
  let rutaFinalImagen = "https://placehold.co/300x300?text=Sin+Foto";

  if (nombreArchivo) {
      if (nombreArchivo.startsWith("http")) {
          rutaFinalImagen = nombreArchivo;
      } else {
          rutaFinalImagen = `/imagenes/${nombreArchivo}`;
      }
  }

  const handleComprar = (e) => {
    e.stopPropagation();
    if (addToCart) {
        addToCart(producto);
        navigate('/carrito');
    }
  };

  const handleAgregar = (e) => {
    e.stopPropagation();
    if (addToCart) {
        addToCart(producto);
        alert("✅ Agregado al carrito"); 
    }
  };

  return (
    <div 
      className="card card-interactive h-100 shadow-sm border-0 animate-fade-in-up" 
      onClick={() => navigate(`/producto/${producto.id}`)} 
      style={{
        borderRadius: '16px',
        overflow: 'hidden',
        transition: 'transform 0.28s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.28s ease'
      }}
    >
        {/* IMAGEN CON ZOOM SUAVE */}
        <div 
          style={{ height: '220px', position: 'relative', overflow: 'hidden' }} 
          className="d-flex align-items-center justify-content-center bg-white border-bottom"
        >
            <img 
                src={rutaFinalImagen} 
                className="p-3 w-100 h-100" 
                alt={producto.nombre} 
                style={{ 
                  maxHeight: '100%', 
                  maxWidth: '100%', 
                  objectFit: 'contain',
                  transition: 'transform 0.35s cubic-bezier(0.16, 1, 0.3, 1)'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.08)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                onError={(e) => { e.target.src = "https://placehold.co/300x300?text=Error+Img"; }}
            />
        </div>

        {/* CUERPO */}
        <div className="card-body d-flex flex-column p-4">
            {/* Título */}
            <h5 className="card-title text-dark fw-bold mb-1" style={{ fontSize: '1.08rem', lineHeight: 1.3 }}>
                {producto.nombre}
            </h5>
            
            {/* Categoría */}
            <h6 className="card-subtitle mb-2 text-primary small fw-semibold">
                {producto.categoria}
            </h6>

            {/* Descripción */}
            <p className="card-text text-muted small" style={{ minHeight: '40px', lineHeight: 1.45 }}>
                {producto.descripcion ? producto.descripcion : <i>Sin descripción</i>}
            </p>

            <div className="mt-auto mb-3">
                <span className="h4 fw-bold text-primary" style={{ letterSpacing: '-0.02em' }}>
                    S/ {Number(producto.precio).toFixed(2)}
                </span>
            </div>

            {/* BOTONES CON MICROINTERACCIONES */}
            <div className="d-grid gap-2">
                <button className="btn btn-dark fw-bold rounded-pill btn-shimmer py-2" onClick={handleComprar}>
                    Comprar ahora
                </button>
                <button className="btn btn-outline-success fw-bold rounded-pill py-2" onClick={handleAgregar}>
                    <i className="bi bi-cart-plus-fill me-1"></i> + Carrito
                </button>
            </div>
        </div>
    </div>
  );
}

export default ProductCard;